/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FullVersionWaitingListItem { 
    id?: number;
    uuid?: string;
    created?: string;
    invoiceNumberMonthly?: number;
    numberOfOffices?: number;
    exclusiveRadius?: number;
    exclusiveDuration?: number;
    exclusiveCustomPrice?: number;
    status?: FullVersionWaitingListItem.StatusEnum;
}
export namespace FullVersionWaitingListItem {
    export type StatusEnum = 'PENDING' | 'APPROVED' | 'REJECTED';
    export const StatusEnum = {
        Pending: 'PENDING' as StatusEnum,
        Approved: 'APPROVED' as StatusEnum,
        Rejected: 'REJECTED' as StatusEnum
    };
}


